import styles from './VilleOnlyHeader.module.css'

import { SvgOfficialLogoVille } from '../../../svg/SvgComponents'

const VilleOnlyHeader = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <SvgOfficialLogoVille />
      </div>
    </header>
  </>
)

export default VilleOnlyHeader

